<splide [options]="sliderOptions" class="slider slider--pink how-it-works-fantasy15">
  @for (slide of slides; track slide.title) {
    <splide-slide>
      <!-- `.splide__slide` is a flex row; this block stacks the image above the title, as in Goal Rush. -->
      <div class="how-it-works-fantasy15__slide">
        <img [src]="slide.img" alt="" class="how-it-works-fantasy15__img" />
        <p class="how-it-works-fantasy15__title">{{ slide.title }}</p>
      </div>
    </splide-slide>
  }
</splide>
